export default __webpack_public_path__ + "static/media/Staff of the Gladiator.d9de3e36.jpg";